/**
 * @author        quanquan
 * @dateTime      2021-03-09 10:40:41
 * @description   helpCentre
 */
import io, { serverAlias } from '@/module/io'

class HelpCentreService {
  queryHelpData (payload) {
    return new Promise((resolve, reject) => {
      io.get(`${serverAlias.operate}/1.0/helpCentre/queryHelpData/${payload}`, res => {
        resolve(res)
      }, e => {
        reject(e)
      })
    })
  }
}

export default new HelpCentreService()



// WEBPACK FOOTER //
// ./src/js/module/apis/helpCentreService.js